const finalFormObj=(data)=>{
    let obj = {};
    for(let i=0;i<data.length;i++){
      let key = data[i].name;
      let val = data[i].value;
      let tempObj={[key]:val};
      obj={
        ...obj,
        ...tempObj
      }
    }
    return obj;
  }

  export default finalFormObj;